import { Checkbox, Select, SelectProps } from 'antd';
import React, { CSSProperties, useState } from 'react';
import { styled } from 'styled-components';
type MultipleSelectProps = SelectProps & {
  value?: string[];
  options?: { value: any, label: string }[];
  onChange?: (val: string[]) => void;
  width?: string
  height?: string
  placeholder?: string
  elementName?: string;
  style?: CSSProperties;
};
const MultipleSelect = ({ value = [], options = [], onChange = () => undefined, width = '15rem', height, elementName, placeholder = 'Select type ...', style, className }: MultipleSelectProps) => {
  const [dirty, setDirty] = useState(false);
  const handleChange = (value: string[]) => {
    onChange(value);
    setDirty(true);
  };

  const selectProps: SelectProps = {
    className,
    mode: 'multiple',
    style: { width: width, height, ...style || {} },
    value: value,
    options: options.map(o => ({
      ...o,
      label: (
        <Checkbox
          onClick={(e) => {
            if (dirty) e.stopPropagation();
            setDirty(false);
          }}
          checked={value.includes(o.value)}
        >
          {o.label}
        </Checkbox>
      )
    })),
    onChange: (val: string[]) => handleChange(val),
    onMouseDown: () => setDirty(false),
    tagRender: (props: any) => {
      return value.length > 1 ? <></> : <div className='tag-label'>{props.label}</div>;
    },
    placeholder: placeholder,
    maxTagCount: 1,
    maxTagPlaceholder: () => value.length === options.length ? 'All ' + (elementName || 'types') : `${value.length} ${elementName || 'types'}`,
    size: 'small',
    showSearch: false,
  };
  return (
    // @ts-ignore
    <TypeItemPickerStyled {...selectProps} />
  );
};

export default MultipleSelect;
const TypeItemPickerStyled = styled(Select) <MultipleSelectProps>`
  &.ant-select-multiple {
    .ant-select-selection-item {
      background: 0;
    }
    .tag-label {
      .ant-checkbox {
        display:none;
      }
    }
  }
`;
